<template>
  <div style="position: absolute;top: 40%;left: 50%;transform: translate(-50%, -50%);">
    <va-progress-circle size="4.5rem" indeterminate color="var(--va-basecolor)" thickness="0.15" />
  </div>
</template>
<script>
export default {
  name: "Loading.vue",
}
</script>